import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FixedChargesByCategoryService } from './fixed-charges-by-category/fixed-charges-by-category.service';
import { WsgSharedModule }  from '@morningstar/wsg/shared';
import { FixedChargesByCategoryComponent } from './fixed-charges-by-category/fixed-charges-by-category.component';
import { LocationsModule } from 'apps/wsg/src/app/shared/locations/locations.module';
import { ChartAllModule, RangeNavigatorAllModule, AccumulationChartAllModule } from '@syncfusion/ej2-angular-charts';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';

@NgModule({
  declarations: [
    FixedChargesByCategoryComponent
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    LocationsModule,
    ChartAllModule, 
    RangeNavigatorAllModule, 
    ButtonModule, 
    AccumulationChartAllModule,
  ],
  providers: [
    FixedChargesByCategoryService
  ],
  exports: [
    FixedChargesByCategoryComponent
  ]
})
export class FixedChargesModule { }
